import type { UIFacetOption } from 'src/components/types/UIFacet';

export const formatOptionCount = (count: UIFacetOption['count']) => {
  if (count === null) {
    return '';
  }

  return `(${count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})`;
};
